import {
  REQUEST_FUNERAL_LIST
} from './mutation-types'

export default {
  [REQUEST_FUNERAL_LIST](state, receivedData) {
    state.funeralList = receivedData.content
    state.funeralListCount = receivedData.totalElements
  }
}